export default __webpack_public_path__ + "static/media/pepe_logo.6828e873.png";